export enum ENVIRONMENTS {
  DEV = "dev",
  QA = "qaint",
  STG = "stg",
  PPE = "ppe",
  PROD = "prod",
}
